import { RouteConfig } from "vue-router";

export const RError503: RouteConfig = {
  path: "503",
  name: "Error503",
  component: () =>
    import(
      /* webpackChunkName: "errors-503" */
      "./VError503.vue"
    ),
  meta: {
    title: "503",
  },
};
